import React from 'react';
import VersionTemplate from '../VersionTemplate/VersionTemplate.jsx'

function GroundLightVersion() {
	return (<VersionTemplate
		version={'1.1.3'}
	/>)
}

export default GroundLightVersion



// WEBPACK FOOTER //
// ./src/react/ui/features/Version/GroundLightVersion.jsx